// extracted by mini-css-extract-plugin
module.exports = {"exchange-record-header":"exchange-record-header-f3fc84e70da4f90457b101d33384d3f3","exchange-record-number":"exchange-record-number-0992a1106681400b2b681e34bf95cc8e"};